import { render } from "./BlacklistView.vue?vue&type=template&id=585215ef&scoped=true"
import script from "./BlacklistView.vue?vue&type=script&lang=js"
export * from "./BlacklistView.vue?vue&type=script&lang=js"

import "./BlacklistView.vue?vue&type=style&index=0&id=585215ef&scoped=true&lang=css"

import exportComponent from "../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-585215ef"]])

export default __exports__